import { createBrowserRouter } from 'react-router'
import { Layout as RootLayout } from '@/components/layout'
import { NotFound } from '@/components/error'

import { Index as DashboardIndex } from '@/pages/dashboard/index'

import { Index as DevicesIndex } from '@/pages/devices/index'
import { Show as DeviceShow } from '@/pages/devices/show'

import { Index as IntegrationsIndex } from '@/pages/integrations/index'
import { Index as EquipmentIndex } from '@/pages/equipment/index'
import { Index as ConnectorsIndex } from '@/pages/connectors/index'

import { Index as ItemTypesIndex } from '@/pages/item_types/index'
import { Show as ItemTypeShow } from '@/pages/item_types/show'
import { ConnectorFamilies as ItemTypeConnectorFamilies } from '@/pages/item_types/connector_families'

import { Index as ItemsIndex } from '@/pages/items/index'
import { Show as ItemShow } from '@/pages/items/show'

import { Index as TestExecutionsIndex } from '@/pages/test_executions/index'
import { Show as TestExecutionsShow} from '@/pages/test_executions/show'


export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    errorElement: <NotFound />,
    children: [
      {
        errorElement: <NotFound />,
        children: [
          { index: true, element: <DashboardIndex /> },
          {
            path: '/devices',
            children: [
              { index: true, element: <DevicesIndex /> },
              { path: ':id', element: <DeviceShow /> },
            ]
          },
          { path: '/integrations', element: <IntegrationsIndex /> },
          { path: '/equipment', element: <EquipmentIndex /> },
          { path: '/connectors', element: <ConnectorsIndex /> },
          {
            path: '/item_types',
            children: [
              { index: true, element: <ItemTypesIndex /> },
              { path: ':id', element: <ItemTypeShow /> },
              { path: ':id/connector_families', element: <ItemTypeConnectorFamilies /> },
            ]
          },
          {
            path: '/items',
            children: [
              { index: true, element: <ItemsIndex /> },
              { path: ':id', element: <ItemShow /> },
            ]
          },
          {
            path: '/tests',
            children: [
              { index: true, element: <TestExecutionsIndex /> },
              { path: ':id', element: <TestExecutionsShow /> },
            ]
          },
        ]
      },
    ]
  },
])
